import { pclnExpt } from '../../../common/fly-experimentation/fly-experimentation'

const isSbs = ({ isRoundtrip, isMultiDestination }) =>
  isRoundtrip ||
  (isMultiDestination &&
    pclnExpt.isVariant('AIR_SEARCH_FIREFLY_MD_SLICE_BY_SLICE'))

const getNumSlices = () => {
  if (typeof window !== 'undefined') {
    return window.PCLN_BOOTSTRAP_DATA.numSlices
  }
  return null
}

const getIsSbs = () => {
  if (typeof window !== 'undefined') {
    return isSbs(window.PCLN_BOOTSTRAP_DATA)
  }
  return false
}

const getIsLastSlice = activeTabId => activeTabId === getNumSlices()

export { getIsSbs, getIsLastSlice, getNumSlices }
